<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate

    },
    data() {
      return {
        dialogVisibility: false,
        isEdit: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              url: api.member.category,
            },
            // {
            //   label: '积分方式',
            //   prop: 'integralType',
            //   type: 'select',
            //   data: this.$utils.getCacheStatus('mbMemberIntegral.integralType')
            // },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            filter: () => {
              return this.$utils.getSysUser().storeId ? false : true
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            filter: () => {
              return this.$utils.getSysUser().storeId ? false : true
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: () => {
              return this.$utils.getSysUser().storeId ? false : true
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {label: '会员类别', prop: 'memberCategoryName', width: '120', align: 'center'},
            {
              label: '积分方式',
              prop: 'integralType',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('mbMemberIntegral.integralType')
            },
            // {label: '消费金额(元)', prop: 'consumeAmt', width: '120', align: 'center', defaultValue: '1'},
            {label: '积分规则', prop: 'integralRule', width: '120', align: 'center'},
            // {label: '创建人', prop: 'createBy', width: '120', align: 'center'},
            {label: '创建时间', prop: 'createDttm', width: '125', align: 'center'},
          ],
          url: api.member.integralSetting
        },
        // 添加字段
        addColumns: {
          labelWidth: '160px',
          span: 12,
          columns: [
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              url: api.member.category,
              rule: [{required: true, message: '请选择会员类别'}],
              isAllline: true
            },
            {label: '积分设置', type: 'title', span: 24},
            {
              label: '消费获得积分',
              type: 'switch',
              prop: 'giveIntegral',
              isAllline: true,
              defaultValue: true,
              change: this.openIntegral
            },
            {
              label: '积分方式',
              type: 'select',
              prop: 'integralType',
              data: this.$utils.getCacheStatus("mbMemberIntegral.integralType"),
              // isShow: false,
              defaultValue: 60,
              rule: [{required: true, message: '请选择积分方式'}],
              // change: this.hide,
            },
            // {
            //   label: '品牌',
            //   type: 'select',
            //   prop: 'retaleId',
            //   multiple: true,
            //   hidden: true,
            //   url: api.store.store,
            // },
            // {
            //   label: '类别',
            //   type: 'select',
            //   prop: 'retaleId',
            //   hidden: true,
            //   multiple: true,
            //   url: api.store.store,
            // },
            // {
            //   label: '消费金额',
            //   type: 'inputNumber',
            //   prop: 'retaleId',
            //   hidden: true,
            //   multiple: true,
            //   min: 0.01,
            //   url: api.store.store,
            // },
            {
              label: '1元获得积分',
              type: 'inputNumber',
              prop: 'consumeAmt',
              rule: [{required: true, message: '请输入获得积分'}],
              // isShow: false,
              // min: 1,
              defaultValue: 0,
              isAllline: true
            },
            // {label: '多倍积分', type: 'title', span: 24},
            // {
            //   label: '会员生日当天',
            //   type: 'switch',
            //   prop: 'birthdayDayMultiple',
            //   isAllline: true,
            //   change: this.openBirthdayDayMultiple
            // },
            // {
            //   label: '积分倍数',
            //   type: 'inputNumber',
            //   prop: 'birthdayDayIntegral',
            //   rule: [{required: false, message: '请输入积分倍数'}],
            //   isAllline: true,
            //   isShow: false,
            // },
            // {
            //   label: '会员生日当月',
            //   type: 'switch',
            //   prop: 'birthdayMonthMultiple',
            //   isAllline: true,
            //   change: this.openBirthdayMonthMultiple
            // },
            // {
            //   label: '积分倍数',
            //   type: 'inputNumber',
            //   prop: 'birthdayMonthIntegral',
            //   rule: [{required: false, message: '请输入积分倍数'}],
            //   isAllline: true,
            //   isShow: false,
            // },
            // {
            //   label: '每天',
            //   type: 'switch',
            //   prop: 'dayMultiple',
            //   isAllline: true,
            //   change: this.openDayMultiple
            // },
            // {
            //   label: '积分倍数',
            //   type: 'inputNumber',
            //   prop: 'dayIntegral',
            //   rule: [{required: false, message: '请输入积分倍数'}],
            //   isAllline: true,
            //   isShow: false,
            // },
            // {
            //   label: '每天开始时间',
            //   type: "dateTimePicker",
            //   prop: 'dayStartTime',
            //   span: 12
            // },
            // {
            //   label: '每天结束时间',
            //   type: "dateTimePicker",
            //   prop: 'dayEndTime',
            //   span: 12
            // },
            // {
            //   label: '每周',
            //   type: 'switch',
            //   prop: 'weekMultiple',
            //   span: 12,
            //   isAllline: true,
            //   change: this.openWeekMultiple
            // },
            // {
            //   label: '每周积分日期',
            //   type: 'select',
            //   prop: 'weekTypes',
            //   multiple: true,
            //   data: this.$utils.getCacheStatus("mbMemberIntegral.weekType"),
            //   rule: [{required: false, message: '请选择日期'}],
            //   span: 12,
            //   isShow: false,
            // },
            // {
            //   label: '积分倍数',
            //   type: 'inputNumber',
            //   prop: 'weekIntegral',
            //   rule: [{required: false, message: '请输入积分倍数'}],
            //   span: 12,
            //   isShow: false,
            // },
            // {
            //   label: '每月',
            //   type: 'switch',
            //   prop: 'monthMultiple',
            //   isAllline: true,
            //   change: this.openMonthMultiple
            // },
            // {
            //   label: '每月积分日期',
            //   type: 'select',
            //   prop: 'monthTypes',
            //   multiple: true,
            //   data: this.$utils.getCacheStatus("mbMemberIntegral.monthType"),
            //   rule: [{required: false, message: '请选择日期'}],
            //   span: 12,
            //   isShow: false,
            // },
            // {
            //   label: '积分倍数',
            //   type: 'inputNumber',
            //   prop: 'monthIntegral',
            //   rule: [{required: false, message: '请输入积分倍数'}],
            //   span: 12,
            //   isShow: false,
            // },
            // {label: '其他设置', type: 'title', span: 24},
            // {
            //   label: '会员优惠价商品记积分',
            //   type: 'switch',
            //   prop: 'discountGoods',
            //   span: 12
            // },
            // {
            //   label: '消费特价商品记积分',
            //   type: 'switch',
            //   prop: 'specialOfferGoods',
            //   span: 12
            // },
            // {
            //   label: '整数累计积分(向下取整)',
            //   type: 'switch',
            //   prop: 'addIntegral',
            //   span: 12
            // },
            // {
            //   label: '积分付款金额不积分',
            //   type: 'switch',
            //   prop: 'integralPaymentAmt',
            //   span: 12
            // },
            {label: '积分付款', type: 'title', span: 24},
            {
              label: '是否开启积分付款',
              type: 'switch',
              prop: 'integralPayment',
              isAllline: true,
              change: this.openIntegralPayment
            },
            {
              label: '抵现比例',
              type: 'inputNumber',
              prop: 'cashOutRatio',
              isAllline: true,
              rule: [{required: false, message: '请输入抵现比例'}],
              isShow: false,
              min: 0.0001,
              max: 0.9999
              // change: this.calc
            },
            {
              label: '积分',
              type: 'inputNumber',
              prop: 'integralPrice',
              span: 12,
              rule: [{required: false, message: '请输入积分'}],
              isShow: false,
              min: 1,
              max: 1
              // change: this.calc
            },
            {
              label: '金额',
              type: 'inputNumber',
              prop: 'price',
              span: 12,
              rule: [{required: false, message: '请输入金额'}],
              isShow: false,
              min: 0.01,
              max: 1
              // change: this.calc
            },
            // {
            //   label: `积分=0.01`,
            //   type: 'inputNumber',
            //   disabled: true,
            //   prop: 'integralRate',
            //   span: 12,
            //   isShow: false,
            // },
            {
              label: '备注',
              type: 'textarea',
              prop: 'remarks',
              span: 20,
              isAllline: true
            },

          ], // 表单label
          url: api.member.integralSetting
        },
        editColumns: {
          labelWidth: '160px',
          span: 12,
          columns: [
            {
              label: '会员类别',
              type: 'select',
              prop: 'memberCategoryId',
              data: [],
              url: api.member.category,
              rule: [{required: false, message: '请输入会员类别'}],
              isAllline: true,
              disabled: true,
            },
            {label: '积分设置', type: 'title', span: 24},
            {
              label: '消费获得积分',
              type: 'switch',
              prop: 'giveIntegral',
              isAllline: true,
              change: this.editOpenIntegral
            },
            {
              label: '积分方式',
              type: 'select',
              prop: 'integralType',
              data: this.$utils.getCacheStatus("mbMemberIntegral.integralType"),
              rule: [{required: true, message: '请选择积分方式'}],
              defaultValue: 60,
              isShow: false
            },
            {
              label: '1元获得积分',
              type: 'inputNumber',
              prop: 'consumeAmt',
              rule: [{required: false, message: '请输入获得积分'}],
              isAllline: true,
              isShow: false
            },
            {label: '积分付款', type: 'title', span: 24},
            {
              label: '是否开启积分付款',
              type: 'switch',
              prop: 'integralPayment',
              isAllline: true,
              change: this.editOpenIntegralPayment,
            },
            {
              label: '抵现比例',
              type: 'inputNumber',
              prop: 'cashOutRatio',
              isAllline: true,
              rule: [{required: false, message: '请输入抵现比例'}],
              isShow: false,
              min: 0.0001,
              max: 0.9999
              // change: this.calc
            },
            {
              label: '积分',
              type: 'inputNumber',
              prop: 'integralPrice',
              span: 12,
              rule: [{required: false, message: '请输入积分'}],
              isShow: false,
              min: 1,
              max: 1
              // change: this.calc
            },
            {
              label: '金额',
              type: 'inputNumber',
              prop: 'price',
              span: 12,
              rule: [{required: false, message: '请输入金额'}],
              isShow: false,
              min: 0.01,
              max: 1
              // change: this.calc
            },
            {
              label: '备注',
              type: 'textarea',
              prop: 'remarks',
              span: 20,
              isAllline: true
            },

          ], // 表单label
          url: api.member.integralSetting
        },
      };
    },
    created() {
    },
    methods: {
      openIntegral(form) {
        let consumeAmt = this.addColumns.columns.filter(item => item.prop === 'consumeAmt')[0];
        let integralType = this.addColumns.columns.filter(item => item.prop === 'integralType')[0];
        if (form['giveIntegral']) {
          consumeAmt.isShow = true;
          consumeAmt.rule[0].required = true;
          integralType.isShow = true;
          integralType.rule[0].required = true;
        } else {
          form['integralType'] = 60;
          form['consumeAmt'] = 0;
          consumeAmt.isShow = false;
          consumeAmt.rule[0].required = false;
          integralType.isShow = false;
          integralType.rule[0].required = false;
        }
      },
      editOpenIntegral(form) {
        let consumeAmt = this.editColumns.columns.filter(item => item.prop === 'consumeAmt')[0];
        let integralType = this.editColumns.columns.filter(item => item.prop === 'integralType')[0];
        if (form['giveIntegral']) {
          consumeAmt.isShow = true;
          consumeAmt.rule[0].required = true;
          integralType.isShow = true;
          integralType.rule[0].required = true;
        } else {
          form.integralType = 60;
          form.consumeAmt = 0;
          consumeAmt.isShow = false;
          consumeAmt.rule[0].required = false;
          integralType.isShow = false;
          integralType.rule[0].required = false;
        }
      },
      openBirthdayDayMultiple(form) {
        let birthdayDayIntegral = this.addColumns.columns.filter(item => item.prop === 'birthdayDayIntegral')[0];
        if (form['birthdayDayMultiple']) {
          birthdayDayIntegral.isShow = true;
          birthdayDayIntegral.rule[0].required = true;
        } else {
          form['birthdayDayIntegral'] = '';
          birthdayDayIntegral.isShow = false;
          birthdayDayIntegral.rule[0].required = false;
        }
      },
      openBirthdayMonthMultiple(form) {
        let birthdayMonthIntegral = this.addColumns.columns.filter(item => item.prop === 'birthdayMonthIntegral')[0];
        if (form['birthdayMonthMultiple']) {
          birthdayMonthIntegral.isShow = true;
          birthdayMonthIntegral.rule[0].required = true;
        } else {
          form['birthdayMonthIntegral'] = '';
          birthdayMonthIntegral.isShow = false;
          birthdayMonthIntegral.rule[0].required = false;
        }
      },
      openDayMultiple(form) {
        let dayIntegral = this.addColumns.columns.filter(item => item.prop === 'dayIntegral')[0];
        if (form['dayMultiple']) {
          dayIntegral.isShow = true;
          dayIntegral.rule[0].required = true;
        } else {
          form['dayIntegral'] = '';
          dayIntegral.isShow = false;
          dayIntegral.rule[0].required = false;
        }
      },
      openWeekMultiple(form) {
        let weekTypes = this.addColumns.columns.filter(item => item.prop === 'weekTypes')[0];
        let weekIntegral = this.addColumns.columns.filter(item => item.prop === 'weekIntegral')[0];
        if (form['weekMultiple']) {
          weekTypes.isShow = true;
          weekIntegral.isShow = true;
          weekTypes.rule[0].required = true;
          weekIntegral.rule[0].required = true;
        } else {
          form['weekTypes'] = [];
          form['weekIntegral'] = '';
          weekTypes.isShow = false;
          weekIntegral.isShow = false;
          weekTypes.rule[0].required = false;
          weekIntegral.rule[0].required = false;
        }
      },
      openMonthMultiple(form) {
        let monthTypes = this.addColumns.columns.filter(item => item.prop === 'monthTypes')[0];
        let monthIntegral = this.addColumns.columns.filter(item => item.prop === 'monthIntegral')[0];
        if (form['monthMultiple']) {
          monthTypes.isShow = true;
          monthIntegral.isShow = true;
          monthTypes.rule[0].required = true;
          monthIntegral.rule[0].required = true;
        } else {
          form['monthTypes'] = [];
          form['monthIntegral'] = '';
          monthTypes.isShow = false;
          monthIntegral.isShow = false;
          monthTypes.rule[0].required = false;
          monthIntegral.rule[0].required = false;
        }
      },
      calc(form) {
        form.integralRate = 0.01 * form.cashOutRatio;
      },
      openIntegralPayment(form) {
        let cashOutRatioInput = this.addColumns.columns.filter(item => item.prop === 'cashOutRatio')[0];
        let integral = this.addColumns.columns.filter(item => item.prop === 'integralPrice')[0];
        let price = this.addColumns.columns.filter(item => item.prop === 'price')[0];
        if (form['integralPayment']) {
          cashOutRatioInput.isShow = true;
          cashOutRatioInput.rule[0].required = true;
          integral.isShow = true;
          integral.rule[0].required = true;
          price.isShow = true;
          price.rule[0].required = true;
          // integralRateInput.isShow = true;
        } else {
          form['cashOutRatio'] = '';
          form['integralPrice'] = '';
          cashOutRatioInput.isShow = false;
          cashOutRatioInput.rule[0].required = false
          integral.isShow = false;
          integral.rule[0].required = false;
          price.isShow = false;
          price.rule[0].required = false;
          // integralRateInput.isShow = false;
        }
      },
      editOpenIntegralPayment(form) {
        let cashOutRatioInput = this.editColumns.columns.filter(item => item.prop === 'cashOutRatio')[0];
        let integral = this.editColumns.columns.filter(item => item.prop === 'integralPrice')[0];
        let price = this.editColumns.columns.filter(item => item.prop === 'price')[0];
        if (form['integralPayment']) {
          cashOutRatioInput.isShow = true;
          cashOutRatioInput.rule[0].required = true;
          integral.isShow = true;
          integral.rule[0].required = true;
          price.isShow = true;
          price.rule[0].required = true;
          // integralRateInput.isShow = true;
        } else {
          form['cashOutRatio'] = '';
          form['integralPrice'] = '';
          cashOutRatioInput.isShow = false;
          cashOutRatioInput.rule[0].required = false
          integral.isShow = false;
          integral.rule[0].required = false;
          price.isShow = false;
          price.rule[0].required = false;
          // integralRateInput.isShow = false;
        }
      },
      hide(form) {
        let num = form.integralType;
        if (num === "50") {
          this.addColumns.columns[3].hidden = false;
          this.addColumns.columns[4].hidden = true;
          this.addColumns.columns[5].hidden = true;
        } else if (num === "40") {
          this.addColumns.columns[3].hidden = true;
          this.addColumns.columns[4].hidden = false;
          this.addColumns.columns[5].hidden = true;
        } else if (num === "10") {
          this.addColumns.columns[3].hidden = true;
          this.addColumns.columns[4].hidden = true;
          this.addColumns.columns[5].hidden = false;
        } else if (num === "30" || num === "20") {
          this.addColumns.columns[3].hidden = true;
          this.addColumns.columns[4].hidden = true;
          this.addColumns.columns[5].hidden = true;
        }
      },
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/member/integral/Setting.vue